// extracted by mini-css-extract-plugin
export default {"Home_main":"pc_Home_main__kOmpW","Pro_main":"pc_Pro_main__2pMk7","PersonCenter_main":"pc_PersonCenter_main__WuCrQ"};